const MatrixStylesheet = () => {
  return (
    <head>
      <link rel="stylesheet" href="/css/matrix.css" />
    </head>
  );
};

export default MatrixStylesheet;
